$(function(){
    footerMenu();
    sendonchange();
    menumobile();
});

function sendonchange(){
    $('[data-send-onchange]').on('change', function(){
        console.log('s');
        $(this).parents('form').trigger('submit');
    });
}

function footerMenu(){
    $('[data-open-footer]').on('click', function(){
        var parent = $(this).parents('[data-open-footer-parent]');
        if($(parent).length){
            $(parent).toggleClass('open');
        }
    });
}

function menumobile(){
    $('[data-menu-mobile]').on('click', function(e){
        e.preventDefault();
        $('#mobile-menu').toggleClass('open');
    });

    $('[data-accordion]').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('data-accordion');
        $(id).toggleClass('open');
        $(this).toggleClass('open');
    });
}